// extracted by mini-css-extract-plugin
module.exports = {"mension":"mension____1dF9"};